<template>
  <div class="tag-create component">
    <input type="text" v-model="name" placeholder="add new tag" @keyup.enter="createItem">
    <div class="slug" v-if="slugName">
      Tag will be stored as slug: <b>{{ slugName }}</b>
    </div>
  </div>
</template>

<script>
  import slug from 'slug'
  import * as tagService from '../../services/tags.service'

  export default {
    name: 'TagCreate',
    watch: {},
    data () {
      return {
        error: false,
        loading: false,
        name: '',
        slugOptions: {
          lower: true,
          charmap: {
            '$': false // trim $
          }
        }

      }
    },

    methods: {
      /**
       * tag name will be stored as slug
       */
      createItem () {
        if (this.slugName.length < 3) return

        this.loading = true
        tagService.create({name: this.slugName})
          .then(response => {
            this.$snotify.success(`Is created, All done!`, `Tag: ${this.slugName}`)
            this.name = ''
            this.$emit('tag-added')
          }).catch(error => {
            this.$snotify.error(error.message, 'Error')
            console.log(error)
          }).finally(() => { this.loading = false })
      }
    },

    computed: {
      slugName () {
        return slug(this.name, this.slugOptions)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .slug {
    padding: 10px 0;
    b {
      font-weight: bold;
      text-decoration: underline;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/profile/TagCreate.vue